// frontend/src/pages/builder/layout.js
// Phase 3 step 7d-3: the builder's three panels, Data | chart | Visual, and
// which side panels are open. Either side collapses to a narrow rail so the
// chart gets the room (the page remembers the choice per browser; it is a
// convenience, never saved with a chart). Pure and unit-tested apart from
// the two storage helpers, which never throw.

export const PANES_KEY = 'connex.builder.panes';
export const RAIL = 44;        // px: the collapsed rail, wide enough for one icon button

export const defaultPanes = () => ({ data: true, visual: true });

/** The grid's column classes for the open panels (literal strings, so Tailwind sees them). */
export function gridClass(panes) {
  const data = panes && panes.data !== false;
  const visual = panes && panes.visual !== false;
  if (data && visual) return 'lg:grid-cols-[250px_minmax(0,1fr)_300px] xl:grid-cols-[260px_minmax(0,1fr)_320px]';
  if (data) return 'lg:grid-cols-[250px_minmax(0,1fr)_44px] xl:grid-cols-[260px_minmax(0,1fr)_44px]';
  if (visual) return 'lg:grid-cols-[44px_minmax(0,1fr)_300px] xl:grid-cols-[44px_minmax(0,1fr)_320px]';
  return 'lg:grid-cols-[44px_minmax(0,1fr)_44px]';
}

/** Anything stored -> a complete panes object; unknown values mean open. */
export function parsePanes(raw) {
  const out = defaultPanes();
  let p = raw;
  if (typeof raw === 'string') {
    try { p = JSON.parse(raw); } catch (err) { return out; }
  }
  if (!p || typeof p !== 'object') return out;
  if (p.data === false) out.data = false;
  if (p.visual === false) out.visual = false;
  return out;
}

export function readPanes() {
  try { return parsePanes(window.localStorage.getItem(PANES_KEY)); } catch (err) { return defaultPanes(); }
}

export function writePanes(panes) {
  try { window.localStorage.setItem(PANES_KEY, JSON.stringify(parsePanes(panes))); } catch (err) { /* private mode etc. */ }
}